/** 
 * @type {InvestorContractsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: [],
    investor_ids: [],
    plan_ids: [],
    status: [],
    appends: [],
}
/** 
* @returns {InvestorContractsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/InvestorContractsFilter.js